import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useState } from 'react';
import { CnMessage, Select, Form, Field, Grid, CnButton, CnIcon, CnTable, CnCardSubCard, CnTag, } from '@alife/cn-ui';
import { PayMethods } from '../../const';
import { saveVasSelfPayerInfo } from '../../api';
const { Row, Col } = Grid;
const FormItem = Form.Item;
const valueRender = (item) => {
    if (item.value == 5) {
        return (React.createElement("span", { className: 'add-itemRender' },
            item.label,
            ' ',
            React.createElement(CnTag, { type: 'primary', color: 'red', size: 'small' }, "\u65B0\u589E")));
    }
    return React.createElement("span", null, item.label);
};
const itemRender = (item) => {
    if (item.value == 5) {
        return (React.createElement("span", { className: 'add-itemRender' },
            item.label,
            ' ',
            React.createElement(CnTag, { type: 'primary', color: 'red', size: 'small' }, "\u65B0\u589E")));
    }
    return React.createElement("span", null, item.label);
};
export default function WarehouseServiceSubCard(props) {
    const { asnCode, canEdit, setCanAddService, selfVasPayerInfo, 
    // setChangeBlg,
    // setChange,
    // setValues,
    // setRemarks,
    loading, columns, dataSource, isZebra, showIndex, operateColumn, cellCopyEnable, canAddService, handleShowServiceDialog, index, length, vasSelfPayerInfo, payerList, allPayerList, handleSearch, } = props;
    const addPayerField = Field.useField();
    const [payerLoading, setPayerLoading] = useState(false);
    const getPayerInfo = useCallback(() => {
        if (selfVasPayerInfo && selfVasPayerInfo?.isDisable) {
            const { vasSelfPayerName, vasSelfAccountType } = selfVasPayerInfo;
            addPayerField.setValues({
                vasSelfPayerName: vasSelfPayerName || null,
                vasSelfAccountType: vasSelfAccountType || null,
            });
            if (vasSelfPayerName) {
                setCanAddService(true);
            }
        }
        else if (vasSelfPayerInfo) {
            addPayerField.setValues({
                vasSelfPayerName: vasSelfPayerInfo?.value || null,
                vasSelfAccountType: vasSelfPayerInfo?.vasSelfAccountType || null,
            });
            if (vasSelfPayerInfo?.value) {
                setCanAddService(true);
            }
        }
        else {
            addPayerField.setValues({
                vasSelfPayerName: null,
                vasSelfAccountType: null,
            });
            setCanAddService(false);
        }
        // setChange(addPayerField.getValue('vasSelfAccountType'));
    }, [asnCode, addPayerField, setCanAddService, selfVasPayerInfo]);
    const [payerFilterList, setPayerFilterList] = useState(payerList);
    // 初始化表单
    useEffect(() => {
        getPayerInfo();
        const disabledTypeCodes = [2, 4, 5];
        if (length > 1) {
            if (selfVasPayerInfo && selfVasPayerInfo?.vasSelfAccountType) {
                setPayerFilterList(payerList);
            }
            else if (vasSelfPayerInfo?.vasSelfAccountType == 1) {
                const filterData = allPayerList.filter((item) => item?.vasSelfAccountType == 1);
                setPayerFilterList(filterData);
            }
            else if (disabledTypeCodes.includes(vasSelfPayerInfo?.vasSelfAccountType)) {
                const filterData = allPayerList.filter((item) => item?.vasSelfAccountType != 1);
                setPayerFilterList(filterData);
            }
            else {
                setPayerFilterList(allPayerList);
            }
        }
        else {
            setPayerFilterList(payerList);
        }
    }, [getPayerInfo, allPayerList]);
    // 会员信息 - 保存 - 接口请求
    const savePayerRequest = (params) => {
        saveVasSelfPayerInfo({
            asnCode,
            ...params,
        })
            .then(() => {
            setCanAddService(true);
            handleSearch();
            CnMessage.success($i18n.get({ id: 'SavedSuccessfully', dm: '保存成功' }));
        })
            .catch((error) => {
            CnMessage.error(error?.message);
        })
            .finally(() => {
            setPayerLoading(false);
        });
    };
    // 会员信息 - 保存 - 数据处理
    const onSavePayer = () => {
        addPayerField.validate((error, values) => {
            if (!error) {
                const { vasSelfPayerName, vasSelfAccountType } = values;
                const { label = '' } = (payerList &&
                    payerFilterList.find((item) => {
                        return item.value === vasSelfPayerName;
                    })) ||
                    {};
                setPayerLoading(true);
                const vasSelfPayer = (label && label?.split(' ')) || [];
                const payerInfo = vasSelfPayer && {
                    vasSelfPayerId: vasSelfPayer?.[1] || '',
                    vasSelfPayerName: vasSelfPayer?.[0] || '',
                    vasSelfAccountType,
                    cnCardSubCardIndex: index,
                };
                // setChangeBlg(vasSelfAccountType);
                if (vasSelfAccountType == '2') {
                    // setValues(null);
                    // setRemarks('');
                }
                savePayerRequest(payerInfo);
            }
        });
    };
    const onNameChange = (v) => {
        if (v) {
            const accountType = payerFilterList?.find((item) => item.value === v)?.vasSelfAccountType;
            addPayerField.setValues({
                vasSelfAccountType: accountType,
            });
            addPayerField.setError('vasSelfAccountType', undefined);
        }
        else {
            addPayerField.setValues({
                vasSelfAccountType: undefined,
            });
        }
    };
    return (React.createElement(CnCardSubCard, { subTitle: `结算${index + 1}`, action: React.createElement(React.Fragment, null,
            canEdit ? (React.createElement(CnButton, { loading: payerLoading, disabled: selfVasPayerInfo?.isDisable || !canEdit, className: 'left-btn', type: 'secondary', onClick: onSavePayer }, $i18n.get({ id: '', dm: '保存结算客户名称' }))) : (React.createElement(CnButton, { className: 'left-btn', disabled: true, type: 'normal' },
                React.createElement(CnIcon, { type: 'lock' }),
                $i18n.get({ id: 'Locked', dm: '已锁定' }))),
            React.createElement(CnButton, { type: 'primary', disabled: !canAddService, onClick: () => handleShowServiceDialog('new', {}, { selfVasPayerInfo, canEdit, vasSelfPayerInfo }) }, $i18n.get({ id: 'NewService', dm: '新增服务' }))) },
        React.createElement(Form, { field: addPayerField },
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 12 },
                    React.createElement(FormItem, { label: $i18n.get({
                            id: 'SettlementCustomerName',
                            dm: '结算客户名称',
                        }), name: 'vasSelfPayerName', required: true, requiredMessage: $i18n.get({
                            id: 'PleaseSelectTheNameOfThe_515199897',
                            dm: '请选择结算客户名称',
                        }) },
                        React.createElement(Select, { disabled: selfVasPayerInfo?.isDisable || !canEdit, showSearch: true, hasClear: true, dataSource: payerFilterList, style: { width: '100%' }, onChange: onNameChange }))),
                React.createElement(Col, { span: 12 },
                    React.createElement(FormItem, { label: $i18n.get({ id: 'SettlementMethod', dm: '结算方式' }), name: 'vasSelfAccountType', required: true, requiredMessage: $i18n.get({
                            id: 'SettlementMethod',
                            dm: '结算方式',
                        }) },
                        React.createElement(Select, { valueRender: valueRender, itemRender: itemRender, disabled: true, showSearch: true, hasClear: true, dataSource: PayMethods, style: { width: '100%' } }))))),
        React.createElement(CnTable, { loading: loading, columns: columns, dataSource: dataSource, isZebra: isZebra, showIndex: showIndex, operateColumn: operateColumn, cellCopyEnable: cellCopyEnable })));
}
